// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"login_wrapper__JQ3gx","texts":"login_texts__dC0HC","p":"login_p__nw_xc","remember":"login_remember__AauEI","actionWith":"login_actionWith__bQsDC"};